export default __webpack_public_path__ + "static/media/Tools-signature-cap60.64c89c2e.jpeg";